import { waterfallChart } from "#root/dashboard/charts/components/waterfall_chart";
export function waterfallChartBox(chart) {
  const chartHolder = document.createElement("div");
  chartHolder.classList.add("chart-holder");
  const yChartAxis = document.createElement("div");
  yChartAxis.classList.add("chart-axis-y");
  chartHolder.appendChild(yChartAxis);
  const chartViewport = document.createElement("div");
  chartViewport.classList.add("chart-viewport");
  chartHolder.appendChild(chartViewport);
  const xChartAxis = document.createElement("div");
  xChartAxis.classList.add("chart-axis-x");
  chartHolder.appendChild(xChartAxis);
  const canvas = document.createElement("canvas");
  canvas.classList.add("chart-canvas");
  chartViewport.appendChild(canvas);
  requestAnimationFrame(() => {
    waterfallChart(canvas, chart, {
      axisX: xChartAxis,
      axisY: yChartAxis
    });
  });
  return chartHolder;
}